import { Components, Theme } from '@mui/material';

export const MuiToggleButtonGroupTheme = (): Components<Theme>['MuiToggleButtonGroup'] => {
  return {
    styleOverrides: {
      root: {
        borderRadius: '6px',
        gap: 4,
        '& .MuiToggleButtonGroup-firstButton': {
          // Undo MUI default border radius
          borderTopRightRadius: '6px',
          borderBottomRightRadius: '6px',
        },
        '& .MuiToggleButtonGroup-lastButton': {
          // Undo MUI default border radius and margin
          marginLeft: 0,
          borderTopLeftRadius: '6px',
          borderBottomLeftRadius: '6px',
        },
        '& .MuiToggleButtonGroup-middleButton': {
          // Undo MUI default border radius and margin
          marginLeft: 0,
          borderRadius: '6px',
        },
      },
    },
  };
};
